// iconRegistry.ts
import {
  ArrowLeft,
  ArrowRight,
  Ban,
  Book,
  Bookmark,
  Building,
  Calendar,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleMinus,
  CirclePlus,
  Download,
  Maximize, // fullscreen
  Filter, // funnel
  GraduationCap,
  Home, // house
  Key,
  LayoutGrid,
  Leaf,
  ListFilter,
  LogIn,
  LogOut,
  Menu,
  MessageCircle,
  Minus,
  Plus,
  RefreshCw,
  RotateCw,
  Search,
  Settings,
  Shield,
  ShoppingCart,
  Square,
  Star,
  ToggleLeft,
  ToggleRight,
  Undo,
  User,
  ZoomIn,
  ZoomOut,
} from "lucide-react";

export const ICON_REGISTRY = {
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  ban: Ban,
  book: Book,
  bookmark: Bookmark,
  building: Building,
  calendar: Calendar,
  check: Check,
  "check-circle": CheckCircle,
  "chevron-down": ChevronDown,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "chevron-up": ChevronUp,
  circle: Circle,
  "circle-minus": CircleMinus,
  "circle-plus": CirclePlus,
  download: Download,
  fullscreen: Maximize,
  funnel: Filter,
  "graduation-cap": GraduationCap,
  house: Home,
  key: Key,
  "layout-grid": LayoutGrid,
  leaf: Leaf,
  "list-filter": ListFilter,
  "log-in": LogIn,
  "log-out": LogOut,
  menu: Menu,
  "message-circle": MessageCircle,
  minus: Minus,
  plus: Plus,
  "refresh-cw": RefreshCw,
  "rotate-cw": RotateCw,
  search: Search,
  settings: Settings,
  shield: Shield,
  "shopping-cart": ShoppingCart,
  square: Square,
  star: Star,
  "toggle-left": ToggleLeft,
  "toggle-right": ToggleRight,
  undo: Undo,
  user: User,
  "zoom-in": ZoomIn,
  "zoom-out": ZoomOut,
} as const;

export type IconName = keyof typeof ICON_REGISTRY;
